export const animateArgs = [
  'expandDown',
  'fadeIn',
  // 'schwoop',
  'growFromTopLeft',
  'pulse',
  'scaleFromCenter',
  'scaleFromTopLeft',
  'scaleOnHover',
  'scaleOnTap',
  'slideOutLeft',
  'slideInLeft',
  'slideInTop',
  'slideInBottom',
  'slideOutBottom',
  'slideOutRight',
  'slideInRight',
]
